import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Grid } from '@material-ui/core';
import renderSelectField from './renderSelectField';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';

class SelectForm extends Component {
  render() {
    const { classes, handleSubmit, name, label, onSelected, dateValue, parameters } = this.props;

    return (
      <form className={classes.form} onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12} xl={12}>
<Field
  name={name}
  id={name}
  component={renderSelectField}
  onChange={e => onSelected(e.target.value)}
  defaultValue={dateValue}
  label={label}
>
  {/* OPCIÓN PLACEHOLDER */}
  <option value="" disabled selected>
    {label}
  </option>

  {/* OPCIONES DINÁMICAS */}
  {parameters.map((v, k) => (
    <option key={k} value={v.value}>
      {v.label}
    </option>
  ))}
</Field>

          </Grid>
        </Grid>
      </form>
    );
  }
}

SelectForm.propTypes = {
  onSelected: PropTypes.func.isRequired,
  parameters: PropTypes.array.isRequired,
};

const SelectReduxForm = reduxForm({
  form: 'SelectForm',
})(SelectForm);

export default setPropsAsInitial(SelectReduxForm);
